<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">

    @if (currentContent !== 'add-new-record') {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Records
        </h4>
        <div class="card-body">
          <h5 class="filters">Filters</h5>
          <form class="bg-light border rounded-lg px-3 pt-2 pb-1 filters" (ngSubmit)="search()">
            <div class="row">
              <div class="form-group col-md-4">
                <label>Title</label>
                <input type="text" class="form-control" [ngClass]="{ 'is-touched': title }" name="title" [(ngModel)]="title" (change)="search()" placeholder="eg: Meeting with...">
              </div>
              <div class="form-group col-md-4">
                <label>Activity</label>
                <select class="form-control" name="activity" [(ngModel)]="activity" (change)="search()">
                  <option value="">All</option>
                  @for (a of activities; track a) {
                    <option [value]="a">{{a}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Status</label>
                <select class="form-control" name="status" [(ngModel)]="status" (change)="search()">
                  <option value="">All</option>
                  @for (s of statuses; track s) {
                    <option [value]="s">{{s}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label>Start date</label>
                <input type="date" class="form-control" [ngClass]="{ 'is-touched': startDate }" name="startDate" [(ngModel)]="startDate" (change)="search()" [pattern]="dateRegexp">
              </div>
              <div class="form-group col-md-3">
                <label>End date</label>
                <input type="date" class="form-control" [ngClass]="{ 'is-touched': endDate }" name="endDate" [(ngModel)]="endDate" (change)="search()" [pattern]="dateRegexp">
              </div>
              <div class="form-group col-md-3">
                <label>Stakeholder</label>
                <input type="hidden" name="politician" [(ngModel)]="politician">
                <app-search-filter [item]="politician"></app-search-filter>
              </div>
              <div class="form-group col-md-3">
                <label>Client</label>
                <select class="form-control" name="client" [(ngModel)]="client" (change)="search()">
                  <option value="">All</option>
                  @for (c of clients; track c) {
                    <option [value]="c._id">{{c.name}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label>Notes</label>
                <input type="text" class="form-control" [ngClass]="{ 'is-touched': notes }" name="notes" [(ngModel)]="notes" (change)="search()" placeholder="eg: keyword">
              </div>
              <div class="form-group col-md-3">
                <label>Follow up</label>
                <select class="form-control" name="followup" [(ngModel)]="followup" (change)="search()">
                  <option value="">All</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Format</label>
                <select class="form-control" name="format" [(ngModel)]="format" (change)="search()">
                  <option value="">All</option>
                  @for (f of formats; track f) {
                    <option [value]="f">{{f}}</option>
                  }
                </select>
              </div>
            </div>
          </form>
          <hr>
          @if (isLoading.records) {
            <p>
              <app-spinner [condition]="isLoading.records"></app-spinner>
            </p>
          }
          @if (!isLoading.records && records?.length === 0) {
            <p>Nothing found.</p>
          }
          @if (isSearching && !isLoading.records && records?.length) {
            <p>
              <span class="badge badge-primary">{{count}}</span> results found:
            </p>
          }
          <div class="row row-cols-1 row-cols-lg-2" [ngClass]="{ 'disabled': isLoading.records }">
            @for (record of records; track record) {
              <div class="col mb-3">
                <app-record [record]="record" [clients]="clients"></app-record>
              </div>
            }
          </div>
          @if (records?.length) {
            <div>
              <app-pagination [isLoading]="isLoading.records" [count]="count" [perPage]="perPage" [page]="page" eventName="getRecords"></app-pagination>
              <app-spinner [condition]="isLoading.records"></app-spinner>
            </div>
          }
        </div>
      </div>
    }

    @if (currentContent === 'add-new-record' && !recordAdded) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Records &raquo; Add new
        </h4>
        <div class="card-body">
          <app-add-record-form></app-add-record-form>
        </div>
      </div>
    }
    @if (currentContent === 'add-new-record' && recordAdded) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Records &raquo; Add new
        </h4>
        <div class="card-body">
          <p>Record added successfully!</p>
          <a class="nav-link" [routerLink]="" (click)="goToTrackRecords()">
            <i class="fa fa-list"></i> Go to records
          </a>
          <a class="nav-link" [routerLink]="" (click)="addAnotherRecord()">
            <i class="fa fa-plus-circle"></i> Add another record
          </a>
        </div>
      </div>
    }

  </div>
</div>
